import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadComponent: () => import('./pages/public/home/home.component').then(m => m.HomeComponent) },
    { path: 'gallery', children: [
        { path: 'image', loadComponent: () => import('./pages/public/galleries/image/image.component').then(m => m.ImageComponent) },
        { path: 'video', loadComponent: () => import('./pages/public/galleries/video/video.component').then(m => m.VideoComponent) },
    ]},
    { path: 'about', loadComponent: () => import('./pages/public/about/about.component').then(m => m.AboutComponent) },
    { path: 'contact', loadComponent: () => import('./pages/public/contact/contact.component').then(m => m.ContactComponent) },
    { path: 'shop', children: [
        { path: '', loadComponent: () => import('./pages/public/shop/shop.component').then(m => m.ShopComponent) },
        { path: ':id', loadComponent: () => import('./pages/public/detail-product/detail-product.component').then(m => m.DetailProductComponent) },
    ]},
    { path: 'legal', loadComponent: () => import('./pages/public/legal-notice/legal-notice.component').then(m => m.LegalNoticeComponent) },
    { path: 'cart', children: [
        { path: '', loadComponent: () => import('./pages/public/cart/cart.component').then(m => m.CartComponent) },
        { path: 'paiement', loadComponent: () => import('./pages/public/payment/payment.component').then(m => m.PaymentComponent) },
    ]},
    { path: 'invoice', loadComponent: () => import('./pages/public/invoice/invoice.component').then(m => m.InvoiceComponent) },
    { path: 'account', children: [
        { path: '', loadComponent: () => import('./pages/private/dashboard/dashboard.component').then(m => m.DashboardComponent) },
        { path: 'invoice/:id', loadComponent: () => import('./pages/private/invoice/invoice.component').then(m => m.InvoiceComponent) },

    ]},
    { path: '', redirectTo: '', pathMatch: 'full' },
    { path: '**', redirectTo: '' }
];